import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom"; 
import { PersistGate } from "redux-persist/integration/react"
import { Provider } from "react-redux"
import Spinner from "./components/Spinner";
import appStore, { persistor } from "./state/store";
import startup from "./Startup";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

startup.configureApp();

ReactDOM.render(
    <Provider store={appStore}>
        <PersistGate loading={<Spinner />} persistor={persistor}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>,
  document.getElementById("content")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
